import * as Styles from './Board.styles';

type BoardProps = {
  children: JSX.Element | JSX.Element[];
};

const Board = ({ children }: BoardProps): JSX.Element => <Styles.Board>{children}</Styles.Board>;

type BoardColumnTitleProps = {
  title: string;
  titleColor?: string;
  count?: number;
};

const BoardColumnTitle = ({ title, titleColor, count }: BoardColumnTitleProps): JSX.Element => (
  <Styles.ColumnTitleContainer>
    <Styles.ColumnTitle color={titleColor}>{title}</Styles.ColumnTitle>
    {count !== undefined && (
      <Styles.ColumnTalentsCount>{count.toString()}</Styles.ColumnTalentsCount>
    )}
  </Styles.ColumnTitleContainer>
);

Board.Column = Styles.BoardColumn;
Board.ColumnTitle = BoardColumnTitle;
Board.Cards = Styles.BoardCards;

export default Board;
